<template>
  <div class="union">
    <!-- Alongshare-->
    <el-row type="flex" :gutter="20" class="share">
      <img class="dot" :src="`${$g.imgPrefix}/img/home/Cardscreens@2x.png`">
      <img class="half-circle" :src="`${$g.imgPrefix}/img/home/Rectangle@2x.png`">
      <el-col :lg="11" :md="12" :sm="24" :xs="24">
        <!-- 在 AlongShare 上以最低价格共享高级订阅服务-->
        <div class="title share-along">
          <!-- 韩语-->
          <template v-if="$g.languageCode==='kr'">
            <span class="ml-6 mr-6 relative">AlongShare <img class='home-circle' :src="`${$g.imgPrefix}/img/home/Vector@2x.webp`"></span>
            <span>{{$t('home.lowerpricesharelarge')}}</span>
          </template>
          <template v-else>
            <span>{{$t('home.lowerpricesharelarge')}}</span>
            <span class="ml-6 mr-6 relative">AlongShare <img class='home-circle' :src="`${$g.imgPrefix}/img/home/Vector@2x.webp`"></span>
          </template>

        </div>
        <!-- 连续 3年提供高质量、价格低廉-->
        <div class="share-desc">{{$t('home.highqualitystreaming')}}</div>
        <!-- 查看详情-->
        <el-button type="primary" round class="green-btn" @click="scrollToId('buy')">{{$t('home.detail')}}</el-button>
      </el-col>
      <el-col :lg="13" :md="12" :sm="24" :xs="24" class="relative">
        <el-carousel v-if="!isEmpty(chatList)" class="share-chat" trigger="click" :autoplay="true" :loop="true" >
          <el-carousel-item v-for="(cItem,cIndex) in chatList" v-if="cItem.status!='0'" :key="cIndex">
            <div class="share-chat-top">
              <img class="share-chat-avatar" :src="cItem.img">
              <div class="share-chat-user">{{ cItem.title }}</div>
            </div>
            <el-tooltip popper-class="large-tooltip" effect="dark" :content="cItem.content" placement="bottom">
             <div class="share-chat-text">
                {{ cItem.content }}
             </div>
            </el-tooltip>
          </el-carousel-item>
        </el-carousel>

        <div class="scroll-container">
          <div class="share-join list-container" v-if="!isEmpty(joinList)">
            <div class="share-join-item" v-for="(jItem,jIndex) in joinList" :key="jIndex">
              <img class="share-join-avatar" :src="jItem.img">
              <div class="share-join-text">{{ jItem.text }}</div>
            </div>
          </div>
          <div class="share-rate">
            <div class="share-rate-year">1 Year-10%</div>
            <!-- 活动多多，收获多多-->
            <div class="share-rate-text">{{$t('home.moreactivities')}}</div>
          </div>
        </div>
      </el-col>
      <div class="green-bg bottom-green"></div>
    </el-row>
    <!-- 购买-->
    <div class="buy" id="buy">
      <div class="orange-bg left-orange"></div>
      <div class="green-bg right-green"></div>
      <div class="buy-list">
        <div class="buy-item"
             @mouseleave="($event)=>mouseLeave($event,i)"
             @mouseenter="($event)=>mouseEnter($event,i)"
             :style="{backgroundColor: hoverIndex===i&&item.isbuy == '1'?hoverItemBg:''}"
             v-for="(item,i) in spuList" :key="i">
          <div class="buy-top">
            <div class="buy-top-gragh" :style="{backgroundColor: hoverIndex===i&&item.isbuy == '1'?hoverGraghBg:''}">
              <img :src="item.homeimg">
            </div>
            <div class="buy-top-amount">
              <span class="buy-top-money">${{ item.price }}</span>
              <!-- 月-->
              <span class="buy-top-month">/ {{$t('home.month')}}</span>
            </div>
          </div>
          <div class="buy-content">
            <ul :class="['buy-content-desc',item.expandFlag?'all':'part']" v-if="!isEmpty(item.id)" v-html="$t('home.detail'+item.id)"></ul>
            <div class="buy-content-fold mb-2">
              <img @click="toggleExpand(item,'expandFlag')" :class="['arrow',item.expandFlag?'up':'']" :src="`${$g.imgPrefix}/img/home/buy-arrow.svg`">
            </div>
          </div>
          <div clas="buy-footer">
            <!-- How Use-->
            <div v-if="false" class="how" @click="howToUse">
              <img class="how-help" :src="`${$g.imgPrefix}/img/home/help.svg`">
              <div class="how-text">How Use</div>
            </div>

            <template v-if="item.goodsname=='share ai'">
              <el-button v-if="item.isbuy == '1'"
                         type="primary" round
                         class="green-btn w-100"
                         :style="hoverIndex===i?buyBtnStyle:{}"
                         @click="goShareAI">{{$t("home.buynow")}}</el-button>
            </template>
            <template v-else>
              <el-button v-if="item.isbuy == '1'"
                         type="primary" round
                         class="green-btn w-100"
                         :style="hoverIndex===i?buyBtnStyle:{}"
                         @click="toBuy(item)">{{$t("home.buynow")}}</el-button>
              <el-button v-else type="info" disabled>{{ $t("home.soldout") }}</el-button>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- 分享 加入订阅-->
    <div class="sub">
      <div class="orange-bg left-orange"></div>
      <div class="orange-bg right-orange"></div>
      <div class="green-bg center-green"></div>
      <!-- <span>分享</span>加入合作-->
      <div class="title tc" v-html="$t('home.sharejoinsubscription')"></div>
      <div class="sub-box">
        <div class="sub-item sub-l">
          <div class="sub-content">
            <img class="sub-content-bg" :src="`${$g.imgPrefix}/img/home/Rectangle5189@2x.webp`">
            <div class="sub-content-top">
              <!-- 与朋友分享Alongshare-->
              <div class="sub-content-title">{{$t('home.shareyoursubscription')}}</div>
              <img class="sub-content-icon" :src="`${$g.imgPrefix}/img/home/image138@2x.webp`">
            </div>
            <ul class="sub-content-text">
              <!-- 凭借专属折扣码。-->
              <li>{{$t('home.availabletime')}}</li>
              <!-- 他人使用你的折扣码购买-->
              <li>{{$t('home.makemoney')}}</li>
              <!-- 你可以获得对应的订单返佣-->
              <li>{{$t('home.widerangesubscription')}}</li>
              <!-- 在佣金面板可以查看推广订单详情-->
              <li>{{$t('home.threestepsshare')}}</li>
            </ul>
          </div>
        </div>
        <div class="sub-item sub-r">
          <div class="sub-content">
            <img class="sub-content-bg" :src="`${$g.imgPrefix}/img/home/Group1000005893@2x.webp`">
            <div class="sub-content-top">
              <!-- 加入合作-->
              <div class="sub-content-title">{{$t('home.joinsubscription')}}</div>
              <img class="sub-content-icon" :src="`${$g.imgPrefix}/img/home/image135@2x.png`">
            </div>
            <ul class="sub-content-text">
              <!-- 在Naver/YouTube/Telegram上自行发布推广帖子/视频  -->
              <li>{{$t('home.saveupsubscriptionfees')}}</li>
              <!-- 推广中包含自己的折扣码 -->
              <li>{{$t('home.securepayment')}}</li>
              <!-- 推广之后可以轻松在“추천 할인”页面查看订单情况 -->
              <li>{{$t('home.manualreview')}}</li>
              <!-- 钱包累积到30美元即可提现 -->
              <li>{{$t('home.oneclickjoin')}}</li>
            </ul>

          </div>
        </div>
      </div>


    </div>
    <!-- 为什么 越来越多 人使用 Alongshare-->
    <div class="use">
      <div class="green-bg left-green"></div>
      <!-- 为什么 越来越多 人使用 Alongshare-->
      <div class="title use-title" v-html="$t('home.whyusealongshare')"></div>
      <div class="use-box">
        <div class="grey-box use-item">
          <img :src="`${$g.imgPrefix}/img/home/Group1000005894@2x.webp`">
          <!-- SSL证书-->
          <div class="use-item-title">{{$t('home.certificate')}}</div>
          <!-- 付款在具有 SSL 安全证书的安全环境中进行-->
          <div class="use-item-desc">{{$t('home.payments')}}</div>
        </div>
        <div class="grey-box use-item">
          <img :src="`${$g.imgPrefix}/img/home/Group1000005895@2x.webp`">
          <!-- 合适的订阅者-->
          <div class="use-item-title">{{$t('home.subscriber')}}</div>
          <!-- 以较低的价格获得高级订阅。-->
          <div class="use-item-desc">{{$t('home.subscriptions')}}</div>
        </div>
        <div class="grey-box use-item">
          <img :src="`${$g.imgPrefix}/img/home/Group1000005896@2x.webp`">
          <!-- 退款保证-->
          <div class="use-item-title">{{$t('home.moneyback')}}</div>
          <!-- 我们提供买家保障，24 小时内可退款。-->
          <div class="use-item-desc">{{$t('home.refund')}}</div>
        </div>
        <div class="grey-box use-item">
          <img :src="`${$g.imgPrefix}/img/home/Group1000005881@2x.webp`">
          <!-- 7×24 实时支持-->
          <div class="use-item-title">{{$t('home.onlinesupport')}}</div>
          <!-- 提供7×24在线私人客服，助您拥有良好的体验-->
          <div class="use-item-desc">{{$t('home.privatecustomer')}}</div>
        </div>
      </div>
    </div>
    <!-- 链接-->
    <div class="link">
      <div class="green-bg right-green"></div>
      <img :src="`${$g.imgPrefix}/img/home/Group33@2x.webp`">
      <img :src="`${$g.imgPrefix}/img/home/Group34@2x.webp`">
      <img :src="`${$g.imgPrefix}/img/home/Group35@2x.webp`">
      <img :src="`${$g.imgPrefix}/img/home/Group36@2x.webp`">
      <img :src="`${$g.imgPrefix}/img/home/Group37@2x.webp`">
      <img :src="`${$g.imgPrefix}/img/home/Group38@2x.webp`">
      <img :src="`${$g.imgPrefix}/img/home/Group39@2x.webp`">
      <img :src="`${$g.imgPrefix}/img/home/Group40@2x.webp`">
    </div>

    <toBuy
        ref="toBuyRef"
        @goPay="goPay"
        :form1Obj="form1"
    />
    <goPay
        ref="goPayRef"
        @closeToBuy="closeToBuy"
        @openBillDetails="openBillDetails"
        :form1Obj="form1"
        :goodsname="goodsname"
        :discountCodeFlag="discountCodeFlag"
    />
    <billingDetails
        ref="billingDetails"
        :form1Obj="form1"
    />

    <htmlModal ref="htmlModalRef">
      <div slot="htmlText" v-html="htmlText"></div>
    </htmlModal>
  </div>
</template>

<script>
import {
  getGoodsspuAll,
  paytypeall,
  getMessageList
} from "@/request/requests";
import {
  isEmpty,
  formatObj,
  MessageError,
  // startLoading
} from "@/util/util";
import toBuy from "./home/toBuy";
import goPay from "./home/goPay";
import billingDetails from "./home/billingDetails";
import htmlModal from "./htmlModal";
export default {
  name: "union",
  components:{
    toBuy,
    goPay,
    billingDetails,
    htmlModal
  },
  data() {
    return {
      spuList: [],
      spu:'',
      goodsname:'',
      payOptions: [],
      skuFilterList:[],
      form1:{
        goodsid: "",
        skuid: "",
        num: "",
        buytype: "",
        paycode: "",
        discountcode: "",
      },
      priceObj:{
        price:0,
        month:'',
        giftstimes:0,
      },
      chatList:[],
      joinList: [],
      hoverItemBg: '',
      hoverGraghBg: '',
      hoverIndex: '',
      buyBtnStyle: {},
      intervalId: null,
      discountCodeFlag:false,
      htmlText:'<h2>ddddd</h2>'
    }
  },
  methods: {
    isEmpty,
    toggleExpand(item,flag){
      this.$set(item,flag,!item[flag]);
    },
    goShareAI(){
      this.$router.push({
        name:'shareAI'
      })
    },
    openBillDetails(){
      this.$nextTick(()=>{
        this.$refs['billingDetails'].init();
      })
    },
    async getMessageList(){
      let params = {
        page: 1,
        size: 10
      }
      this.chatList = [];
      let res = await getMessageList(this.$qs.stringify(params));
      if (res.status == "200") {
        this.chatList = res.data.list;
        if(!isEmpty(this.chatList)){
          this.chatList.forEach(item=>{
            this.$set(item,'img',`${this.$g.imgPrefix}/img/home/avatar.svg`);
          })
        }
      } else {
        MessageError(res.msg);
      }
    },
    howToUse(){
      this.$refs['htmlModalRef'].init();
    },
    closeToBuy(){
      this.$nextTick(()=>{
        this.$refs['toBuyRef'].closeDialog();
      })
    },
    toBuy(spu){
      this.spu = spu;
      this.goodsname = this.spu.goodsname;
      this.form1 = {
        goodsid: spu.id,
        num: 1,
        buytype: "1",
        paycode: "",
        //this.payOptions[0].value,
        discountcode: "",
        skuid: spu.skus[0].id
      }
      this.$nextTick(()=>{
        this.$refs['toBuyRef'].init(formatObj(this.spu));
      })
    },
    /**
     * @param priceObj 价格对象
     * @param form1
     * @param discountCodeFlag 折扣码是否已经生效 true/false
     */
    goPay(priceObj,form1,discountCodeFlag){
      this.discountCodeFlag = discountCodeFlag;
      this.form1 = form1;
      this.$nextTick(()=>{
        this.$refs['goPayRef'].init(priceObj);
      })
    },
    async paytypeallInfo() {
      let res = await paytypeall();
      if (res.status == "200") {
        this.payOptions = res.data;
      } else {
        MessageError(res.msg);
      }
    },
    async getGoodsspuAllInfo() {
      //let loading = startLoading();
      let res = await getGoodsspuAll();
      if (res.status == "200") {
        this.spuList = res.data;
        // 找到 id 为 x 的项目
        let itemToMove = this.spuList.find(item => item.id === 11);
        if (itemToMove) {
          // 从原列表中移除该项目
          this.spuList = this.spuList.filter(item => item.id !== 11);
          // 如果登录 将该项目插入到列表的第二个位置（索引 1 处）
          let token = this.$cookies.get('token');
          if (token) {
            this.spuList.splice(1, 0, itemToMove);
          }
        }
        if(!this.isEmpty(this.spuList)){
          this.spuList.forEach((sItem)=>{
            this.$set(sItem,'expandFlag',false);
          })
        }

        //loading.close();
      } else {
        MessageError(res.msg);
        // loading.close();
      }
      // loading.close();
    },
    generateRandomTime() {
      let isHour = Math.random() > 0.5;
      if (isHour) {
        let hours = Math.floor(Math.random() * 24);
        return this.$t('home.hoursjoin',{hours});
      } else {
        let minutes = Math.floor(Math.random() * 60);
        return this.$t('home.minutesjoin',{minutes})
      }
    },

    getJoinList() {
      let list = [];
      this.joinList = [];
      for (let i = 0; i < 20; i++) {
        list.push({
          img: `${this.$g.imgPrefix}/img/home/avatar.svg`,
          text: this.generateRandomTime()
        })
      }
      this.joinList = list;
      this.startScrolling();
    },
    startScrolling() {
      this.stopScrolling();
      this.intervalId = setInterval(() => {
        let container = this.$el.querySelector('.list-container');
        if (container) {
          container.scrollTop += 1;
          if (container.scrollHeight - container.scrollTop === container.clientHeight) {
            container.scrollTop = 0;
          }
        }
      }, 30);
    },
    stopScrolling() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    mouseEnter($event, i) {
      this.hoverIndex = i;
      this.hoverGraghBg = '#fff';
      this.hoverItemBg = '#84F0AA';
      this.buyBtnStyle = {background: '#000!important', color: '#fff'};
    },
    mouseLeave($event, i) {
      this.hoverIndex = i;
      this.hoverGraghBg = '#84F0AA';
      this.hoverItemBg = '#fff';
      this.buyBtnStyle = {background: '#84F0AA', color: '#000'};
    },
    scrollToId(id) {
      const yOffset = -40;
      const element = document.getElementById(id);
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});
    }
  },
  mounted() {
    let usercode = this.$route.query.usercode;
    if (usercode) {
      this.$cookies.set("usercode", usercode);
    }
    this.getJoinList();
    this.getGoodsspuAllInfo();
    this.paytypeallInfo();
    this.getMessageList();
  },
  beforeDestroy() {
    this.stopScrolling();
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/union.scss";

.scroll-container {
  position: relative;
  width: 100%;
  height: 274px;
  margin-top:34px;
  @media(max-width: 768px) {
    height: 205px;
  }
}

.list-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
}


</style>
<style lang="scss">
.large-tooltip.el-tooltip__popper {
  width: 20%;
  @media (max-width:992px) {
    width: 70%;
  }
}
</style>